import Sidebar from "../components/sidebar/Sidebar";

const AdminPageContainer = ({ element }) => {
  return (
    <>
      <Sidebar element={element} />
    </>
  );
};

export default AdminPageContainer;
